export default __webpack_public_path__ + "static/ogImage-1f140e4030b1212704112b32982b0306.png";